export enum AppOnboardingSteps {
  ACCOUNTS_STEP = "accounts",
  EVENT_TYPES_STEP = "event-types",
  CONFIGURE_STEP = "configure",
}
